module.exports = __webpack_public_path__ + "assets/icons/ic_add-7a5c.svg";